import React from 'react';
import { Title } from '@mantine/core';
import type { ComponentProps } from 'react';
import classes from './TitleDecor.module.scss';

// Берём все пропы, которые принимает Mantine <Title />
type TitleDecorProps = ComponentProps<typeof Title>;

export const TitleDecor = ({ children, ...props }: TitleDecorProps) => (
    <Title component="h1" className={classes.titleDecor} {...props}>
        {children}
    </Title>
);